











































































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import TopBar from '@/components/widgets/TopBar.vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';
import {
  CampaignFormDataInterface,
  CampaignFormInterface,
  CampaignInterface,
  DropdownList,
  ScheduleTime,
  Ssp,
  Domains,
  IChipsData,
  typeTraffic,
  ICollectionTabsData,
  ERegionType,
  ETargetTypes,
  EImpressions,
  ELimitGoal,
  ELimitType,
  ECappingType,
  EDurationType,
  ECampaignTabs,
} from '@/types';
import { CampaignSettingsIntarface } from '@/types/campaign/settings';
import { CampaignTargetsInterface } from '@/types/campaign/targets';
import Tabs from '@/components/widgets/Tabs.vue';
import TheSettings from '@/components/campaign/settings/TheSettings.vue';
import TheTargets from '@/components/campaign/targets/TheTargets.vue';
import TheCreativesForm from '@/components/campaign/creatives/TheCreativesForm.vue';
import Button from '@/components/form/Button.vue';
import filterParams from '@/components/table/utils/filterParameters';
import Preloader from '@/components/preloader/Preloader.vue';
import { ICreative } from '@/types/campaign/creatives';
import CreativeService from '@/services/CreativeService';
import { getCreativeStorePath } from '@/helpers/creativeHelpers';

export default Vue.extend({
  name: 'CampaignForm',
  components: {
    FieldCheckbox,
    TopBar,
    TheSettings,
    TheTargets,
    TheCreativesForm,
    Tabs,
    Button,
    Preloader,
  },

  props: {
    campaign: Object as PropType<CampaignInterface>,
    errors: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
    },
    nameSubmit: {
      type: String,
    },
    typeTrafic: {
      type: Array as PropType<Array<DropdownList>>,
      default: () => [],
    },
    isSavingForm: {
      type: Boolean,
      default: false,
    },
    loadData: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    this.loadGroup();
    this.initForm(this.campaign);
    this.setGroup(this.campaign);
  },

  destroyed() {
    CreativeService.clearCreativeStore();
  },

  watch: {
    campaign(campaign: CampaignInterface) {
      this.loadGroup();
      this.initForm(campaign);
      this.setGroup(campaign);
      this.checkValidationOnLoad();
    },
    errors(errors) {
      if (errors.length) {
        this.resetFormErrors();
        errors.map((item) => {
          this.setFormError(item.field, item.message);
        });
      }
    },
    group(newValue, oldValue) {
      if (newValue?.id === oldValue?.id) return;

      this.setGroup(this.campaign);
    },
    creativesIsValid(newValue) {
      this.tabsName.creatives.isValid = newValue;
    },
    generalSettingsIsValid(newValue) {
      this.tabsName.settings.isValid = newValue;
    },
  },

  computed: {
    ...mapGetters({
      group: 'campaignGroups/getGroup',
      allCreatives: getCreativeStorePath('getAllCreatives'),
      showcases: getCreativeStorePath('getShowcases'),
      allCreativesHaveErrors: getCreativeStorePath('getAllCreativesHaveErrors'),
    }),
    checkFormStatus(): number {
      return this.form.campaign.status &&
        this.form.campaign.status.value == 'active'
        ? 1
        : 0;
    },
    settingsData(): CampaignSettingsIntarface {
      return {
        loadData: this.loadData,
        generalSettings: {
          name: this.form.campaign.name || '',
          advertiser_domain: this.form.campaign.advertiser_domain,
          advertising_category: this.form.campaign.advertising_category,
          geo_type: this.form.campaign.geo_type,
          geo_values: this.form.campaign.geo_values,
          type_traffic: this.form.campaign.type_traffic,
          errors: {
            name: this.form.campaign.errors.name,
            advertiser_domain: this.form.campaign.errors.advertiser_domain,
            advertising_category:
              this.form.campaign.errors.advertising_category,
            type_traffic: this.form.campaign.errors.type_traffic,
            geo_values: this.form.campaign.errors.geo_values,
          },
        },
        inventory: {
          is_inventory: this.form.campaign.is_inventory,
          ssp_targets: this.form.campaign.ssp_targets,
          errors: {
            ssp_targets: this.form.campaign.errors.ssp_targets,
          },
        },
        buyingStrategy: {
          is_use_price_setting: this.form.campaign.is_use_price_setting,
          target_type: this.form.campaign.target_type,
          impression: this.form.campaign.impression,
          increase_on: this.form.campaign.increase_on,
          max_cpm: this.form.campaign.max_cpm,
          max_cpc: this.form.campaign.max_cpc,
          errors: {
            target_type: this.form.campaign.errors.target_type,
            impression: this.form.campaign.errors.impression,
            increase_on: this.form.campaign.errors.increase_on,
            max_cpm: this.form.campaign.errors.max_cpm,
          },
        },
        limits: {
          is_limit_budget: this.form.campaign.is_limit_budget,
          max_cpc: this.form.campaign.max_cpc,
          limit_type: this.form.campaign.limit_type,
          limit_goal: this.form.campaign.limit_goal,
          limit_budget: this.form.campaign.limit_budget,
          errors: {
            is_limit_budget: this.form.campaign.errors.is_limit_budget,
            limit_budget: this.form.campaign.errors.limit_budget,
            max_cpc: this.form.campaign.errors.max_cpc,
          },
        },
        schedule: {
          is_schedule: this.form.campaign.is_schedule,
          date: [this.form.campaign.from_date, this.form.campaign.to_date],
          times: this.form.campaign.schedule,
        },
      };
    },
    targetsData(): CampaignTargetsInterface {
      return {
        loadData: this.loadData,
        deviceTargets: {
          is_unique_users: this.form.campaign.is_unique_users,
          is_use_predictor_ctr: this.form.campaign.is_use_predictor_ctr,
          contextual_analysis: this.form.campaign.contextual_analysis,
          is_use_target: this.form.campaign.is_use_target,
          user_targets: this.form.campaign.user_targets,
          languages: this.form.campaign.languages,
          is_device_targets: this.form.campaign.is_device_targets,
          os: this.form.campaign.os,
          device_types: this.form.campaign.device_types,
          strategy_id: this.form.campaign.strategy_id,
          errors: {
            is_use_predictor_ctr:
              this.form.campaign.errors.is_use_predictor_ctr,
            contextual_analysis: this.form.campaign.errors.contextual_analysis,
            is_use_target: this.form.campaign.errors.is_use_target,
            user_target: this.form.campaign.errors.user_target,
            languages: this.form.campaign.errors.languages,
            strategy_id: this.form.campaign.errors.strategy_id,
          },
        },
        contextualTarget: {
          is_contextual_target: this.form.campaign.is_contextual_target,
          categories: this.form.campaign.categories,
          keywords: this.form.campaign.keywords,
        },
        frequencyCapping: {
          is_frequency_capping: this.form.campaign.is_frequency_capping,
          capping_type: this.form.campaign.capping_type,
          capping_value: this.form.campaign.capping_value,
          duration_type: this.form.campaign.duration_type,
          duration_value: this.form.campaign.duration_value,
          errors: {
            capping_type: this.form.campaign.errors.capping_type,
            capping_value: this.form.campaign.errors.capping_value,
            duration_type: this.form.campaign.errors.duration_type,
            duration_value: this.form.campaign.errors.duration_value,
          },
        },
        audiences: {
          audiences: this.form.campaign.audiences,
        },
        blackWhiteList: {
          toggleListSites: this.form.toggleListSites,
          black_site_ids: this.form.campaign.black_site_ids,
          white_site_ids: this.form.campaign.white_site_ids,
        },
      };
    },
    routerBack() {
      const url = new URLSearchParams(filterParams.getUrlBack() || '');

      if (this.form.campaign.group_id) {
        url.set('group_id', this.form.campaign.group_id.toString());
      }

      const backUrl = decodeURIComponent(url.toString());

      this.$emit('setBackUrl', backUrl);
      return backUrl;
    },
    tabSettings(): string {
      return ECampaignTabs.SETTINGS;
    },
    tabTargets(): string {
      return ECampaignTabs.TARGETS;
    },
    tabCreatives(): string {
      return ECampaignTabs.CREATIVES;
    },
    someTabsIsNotValid(): boolean {
      let isValid = false;

      for (const tab in this.tabsName) {
        if (!this.tabsName[tab].isValid) {
          isValid = true;
        }
      }

      return isValid;
    },
    generalSettingsIsValid(): boolean {
      let isValid = true;

      for (const field in this.form.campaign.errors) {
        if (
          !this.settingsData.generalSettings[field] ||
          !this.settingsData.inventory[field]
        ) {
          isValid = false;
        }
      }
      return isValid;
    },
    creativesIsValid(): boolean {
      return Boolean(this.allCreativesHaveErrors?.length === 0);
    },
  },

  methods: {
    ...mapActions({
      invalidFormNotificationAction: 'invalidFormNotification',
    }),
    async loadGroup() {
      if (!this.group) {
        const groupId = filterParams.getParamFromUrl('group_id');
        if (groupId) {
          await this.$store.dispatch('campaignGroups/loadGroup', {
            id: groupId,
          });
        }
      }
    },
    setGroup(campaign: CampaignInterface) {
      const isClone = filterParams.getParamFromUrl('clone');

      if (campaign?.group && !isClone) {
        this.$store.commit('campaignGroups/setGroup', campaign.group);

        if (campaign.group?.id) {
          filterParams.changeUrlParams('group_id', campaign.group.id);
        }
        return;
      }

      if (this.group?.id) {
        this.form.campaign.group_id = this.group.id;
      }
    },
    initForm(campaign: CampaignInterface): boolean {
      if (!campaign) {
        return false;
      }

      this.form.toggleListSites = campaign.white_site_ids ? 1 : 0;
      this.form.campaign = {
        group_id: campaign.group?.id ?? null,
        id: campaign.id,
        name: campaign.name,
        advertiser_domain: campaign.advertiser_domain,
        full_name: campaign.full_name,
        type_traffic: campaign.type_traffic,
        status: campaign.status,
        is_unique_users: campaign.is_unique_users,
        is_use_predictor_ctr: campaign.is_use_predictor_ctr,
        is_use_price_setting: campaign.is_use_price_setting ?? 0,
        is_limit_budget:
          campaign.is_limit_budget ?? campaign.is_limit_budget ? 1 : 0,
        is_use_target: campaign.is_use_target ?? campaign.is_use_target ? 1 : 0,
        is_contextual_target: campaign.is_contextual_target ?? 0,
        contextual_analysis: campaign.contextual_analysis,
        keywords: campaign.keywords,
        black_site_ids: campaign.black_site_ids,
        white_site_ids: campaign.white_site_ids,
        is_inventory: campaign.is_inventory ?? 1,
        ssp_targets: campaign.ssp_targets?.map((item: Ssp) => item),
        advertising_category: campaign?.advertising_category
          ? [campaign.advertising_category]
          : [],
        user_targets: campaign.user_targets?.map((item: Ssp) => {
          return item.value;
        }),
        languages: campaign.languages?.map((item) => {
          return item.code;
        }),
        geo_type: campaign.geo_type || ERegionType.INCLUDE,
        geo_values:
          campaign.geo_values?.map((geo) => ({
            label: geo.name,
            value: geo.code,
            type: geo.type,
          })) || [],
        is_device_targets: campaign.is_device_targets ?? 0,
        os: campaign.os?.map((item) => {
          return item.name;
        }),
        categories: campaign.categories?.map((item: IChipsData) => item),
        device_types: campaign.device_types?.map((item) => {
          return item.value;
        }),
        target_type: campaign.target_type || ETargetTypes.CPM,
        impression: campaign.impression || EImpressions.FIXED_CPM,
        max_cpc: campaign.max_cpc || '',
        max_cpm: campaign.max_cpm || '',
        increase_on: campaign.increase_on || '',
        limit_type: campaign.limit_type || ELimitType.SPEND,
        limit_goal: campaign.limit_goal || ELimitGoal.TOTAL,
        limit_budget: campaign.limit_budget || '',
        errors: {},
        from_date: campaign.from_date || '',
        to_date: campaign.to_date || '',
        is_schedule: campaign.is_schedule ?? 0,
        schedule: campaign.schedule?.map((item) => item) || [],
        domains: campaign.domains?.map((item) => item),
        changed_domains: [],
        audiences: campaign.audiences?.map((audience) => {
          return {
            id: audience.id,
            name: audience.name,
            parent_id: audience.id,
            value: audience.id.toString(),
          };
        }),
        is_frequency_capping: campaign.is_frequency_capping ?? 0,
        strategy_id: campaign.strategy_id || null,
        capping_type: campaign.capping_type || ECappingType.IMPRESSIONS,
        capping_value: campaign.capping_value || '',
        duration_type: campaign.duration_type || EDurationType.DAY,
        duration_value: campaign.duration_value || '',
      } as CampaignFormInterface;
      return true;
    },
    isUsePredictorCtrChange(value): void {
      if (this.form.campaign) {
        this.form.campaign.is_use_predictor_ctr = value.toString();
      }
    },
    statusChange(): void {
      if (this.form.campaign?.status) {
        if (this.form.campaign.status.value === 'active') {
          this.form.campaign.status.label = this.$t(
            'body.topBar.status.draft'
          ) as string;
          this.form.campaign.status.value = 'draft';
        } else {
          this.form.campaign.status.label = this.$t(
            'body.topBar.status.active'
          ) as string;
          this.form.campaign.status.value = 'active';
        }
      }
    },
    setFormError(field: string, message): void {
      if (this.form.campaign) {
        if (!this.form.campaign.errors[field]) {
          Vue.set(this.form.campaign.errors, field, []);
        }
        this.form.campaign.errors[field].push(message);
      }
    },
    resetFormErrors() {
      if (!this.form.campaign) return;
      this.form.campaign.errors = {};
    },
    validateSettings() {
      if (!this.form.campaign) {
        return false;
      }
      this.resetFormErrors();
      let success = true;

      if (!this.form.campaign.name || this.form.campaign.name === '') {
        success = false;
        this.setFormError('name', this.$t('errors.required'));
      }
      if (
        !this.form.campaign.advertiser_domain ||
        this.form.campaign.advertiser_domain === ''
      ) {
        success = false;
        this.setFormError('advertiser_domain', this.$t('errors.required'));
      }
      if (
        this.form.campaign.advertiser_domain &&
        !/^(https?:\/\/)?[a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z0-9]{2,})+/.test(
          this.form.campaign.advertiser_domain
        )
      ) {
        success = false;
        this.setFormError('advertiser_domain', this.$t('errors.validDomain'));
      }
      if (!this.form.campaign?.geo_values?.length) {
        success = false;
        this.setFormError('geo_values', this.$t('errors.required'));
      }
      if (!this.form.campaign.type_traffic) {
        success = false;
        this.setFormError('type_traffic', this.$t('errors.required'));
      }
      if (!this.form.campaign.ssp_targets?.length) {
        success = false;
        this.setFormError('ssp_targets', this.$t('errors.required'));
      }
      if (!this.form.campaign.advertising_category?.length) {
        success = false;
        this.setFormError('advertising_category', this.$t('errors.required'));
      }
      if (
        this.form.campaign.limit_budget &&
        !Number(this.form.campaign.limit_budget)
      ) {
        success = false;
        this.setFormError('limit_budget', this.$t('errors.onlyNumbers'));
      }

      return success;
    },
    async checkValidationOnLoad() {
      if (filterParams.getParamFromUrl('validate')) {
        await this.tabsValidate();
        this.switchToFirstInvalidTab();
        filterParams.deleteParamFromUrl('validate');
      }
    },
    validateCreatives() {
      CreativeService.validateCreatives(this.allCreatives);
    },
    async tabsValidate() {
      for (const tabName in this.tabsName) {
        await this.tabValidate(tabName);
      }
    },
    async tabValidate(tabName: string) {
      switch (tabName) {
        case ECampaignTabs.SETTINGS:
          this.validateSettings();
          break;
        case ECampaignTabs.CREATIVES:
          await this.validateCreatives();
          break;
      }

      this.tabsName[tabName].isCheck = true;
    },
    switchToFirstInvalidTab() {
      for (const tab in this.tabsName) {
        if (!this.tabsName[tab].isValid) {
          this.changeActiveTab(tab);
          break;
        }
      }
    },
    changeActiveTab(activeTab: string) {
      this.activeTab = activeTab;
    },
    closeForm() {
      this.$router.push(this.routerBack);
    },
    async submitForm() {
      if (!this.form.campaign) return;

      await this.tabsValidate();

      if (this.someTabsIsNotValid) {
        this.invalidFormNotificationAction();
        this.switchToFirstInvalidTab();
        return;
      }

      const formData = new FormData();

      if (this.form.campaign.group_id) {
        formData.append('group_id', this.form.campaign.group_id.toString());
      }

      if (this.form.campaign.id) {
        formData.append('id', this.form.campaign.id.toString());
      }

      if (this.form.campaign.name) {
        formData.append('name', this.form.campaign.name);
      }

      if (this.form.campaign.advertiser_domain) {
        formData.append(
          'advertiser_domain',
          this.form.campaign.advertiser_domain
        );
      }

      if (this.form.campaign.type_traffic) {
        formData.append('type_traffic', this.form.campaign.type_traffic);
      }

      if (this.form.campaign.status) {
        formData.append('status', this.form.campaign.status.value);
      }

      if (this.form.campaign.is_unique_users !== null) {
        formData.append(
          'is_unique_users',
          this.form.campaign.is_unique_users.toString()
        );
      }

      if (this.form.campaign.is_use_predictor_ctr !== null) {
        formData.append(
          'is_use_predictor_ctr',
          this.form.campaign.is_use_predictor_ctr.toString()
        );
      }

      if (this.form.campaign.is_use_price_setting !== null) {
        formData.append(
          'is_use_price_setting',
          this.form.campaign.is_use_price_setting.toString()
        );
      }

      if (this.form.campaign.is_use_target !== null) {
        formData.append(
          'is_use_target',
          this.form.campaign.is_use_target.toString()
        );
      }

      if (this.form.campaign.is_limit_budget !== null) {
        formData.append(
          'is_limit_budget',
          this.form.campaign.is_limit_budget.toString()
        );
      }

      if (this.form.campaign.contextual_analysis !== null) {
        formData.append(
          'contextual_analysis',
          this.form.campaign.contextual_analysis.toString()
        );
      }

      if (this.form.campaign.keywords) {
        formData.append('keywords', this.form.campaign.keywords.toString());
      }

      if (this.form.toggleListSites) {
        if (this.form.campaign.white_site_ids) {
          formData.append('white_site_ids', this.form.campaign.white_site_ids);
        } else {
          formData.append('white_site_ids', '');
        }

        formData.append('black_site_ids', '');
      } else {
        if (this.form.campaign.black_site_ids) {
          formData.append('black_site_ids', this.form.campaign.black_site_ids);
        } else {
          formData.append('black_site_ids', '');
        }

        formData.append('white_site_ids', '');
      }

      if (this.form.campaign.target_type) {
        formData.append('target_type', this.form.campaign.target_type);
      }

      if (this.form.campaign.impression) {
        formData.append('impression', this.form.campaign.impression);
      }

      if (this.form.campaign.max_cpc) {
        formData.append('max_cpc', this.form.campaign.max_cpc.toString());
      }

      if (this.form.campaign.max_cpm) {
        formData.append('max_cpm', this.form.campaign.max_cpm.toString());
      }

      if (this.form.campaign.increase_on) {
        formData.append(
          'increase_on',
          this.form.campaign.increase_on.toString()
        );
      }

      if (this.form.campaign.limit_type) {
        formData.append('limit_type', this.form.campaign.limit_type.toString());
      }

      if (this.form.campaign.limit_goal) {
        formData.append('limit_goal', this.form.campaign.limit_goal.toString());
      }

      if (this.form.campaign.limit_budget) {
        formData.append(
          'limit_budget',
          this.form.campaign.limit_budget.toString()
        );
      }

      if (this.form.campaign.is_use_target != null) {
        formData.append(
          'is_use_target',
          this.form.campaign.is_use_target.toString()
        );
      }

      if (this.form.campaign.geo_type) {
        formData.append('geo_type', this.form.campaign.geo_type);
      }

      if (this.form.campaign.geo_values?.length) {
        this.form.campaign.geo_values.map((geo, index) => {
          formData.append(
            'geo_values[' + index + '][type]',
            geo.type.toString()
          );
          formData.append(
            'geo_values[' + index + '][code]',
            geo.value.toString()
          );
        });
      }

      if (this.form.campaign.is_device_targets !== null) {
        formData.append(
          'is_device_targets',
          this.form.campaign.is_device_targets.toString()
        );
      }

      if (this.form.campaign.user_targets?.length) {
        this.form.campaign.user_targets.map((item) => {
          formData.append('user_targets[]', item.toString());
        });
      } else {
        formData.append('user_targets[]', '[]');
      }

      if (this.form.campaign.device_types?.length) {
        this.form.campaign.device_types.map((item) => {
          formData.append('device_types[]', item.toString());
        });
      } else {
        formData.append('device_types[]', '[]');
      }

      if (this.form.campaign.is_inventory !== null) {
        formData.append(
          'is_inventory',
          this.form.campaign.is_inventory.toString()
        );
      }

      if (this.form.campaign.ssp_targets?.length) {
        this.form.campaign.ssp_targets.map((item) => {
          formData.append('ssp_targets[]', item.value.toString());
        });
      }

      if (this.form.campaign.advertising_category?.length) {
        formData.append(
          'advertising_category',
          this.form.campaign.advertising_category[0].value.toString()
        );
      } else {
        formData.append('advertising_category', '');
      }

      if (this.form.campaign.languages?.length) {
        this.form.campaign.languages.map((item) => {
          formData.append('language_code[]', item.toString());
        });
      } else {
        formData.append('language_code[]', '[]');
      }

      if (this.form.campaign.os?.length) {
        this.form.campaign.os.map((item) => {
          formData.append('os[]', item.toString());
        });
      } else {
        formData.append('os[]', '[]');
      }

      if (this.form.campaign.is_contextual_target !== null) {
        formData.append(
          'is_contextual_target',
          this.form.campaign.is_contextual_target.toString()
        );
      }

      if (this.form.campaign.keywords) {
        formData.append('keywords', this.form.campaign.keywords.toString());
      }

      if (
        this.form.campaign.categories &&
        this.form.campaign.categories.length
      ) {
        this.form.campaign.categories.map((item) => {
          formData.append('categories[]', item.value);
        });
      } else {
        formData.append('categories[]', '[]');
      }

      formData.append(
        'status',
        this.form.campaign.status == null || !this.form.campaign.status.value
          ? 'draft'
          : this.form.campaign.status.value
      );

      if (this.allCreatives.allIds.length) {
        let creative: ICreative;

        this.allCreatives.allIds.map(
          (creativeId: string, creativeIndex: number) => {
            creative = this.allCreatives.byId[creativeId];

            if (
              creative.id &&
              this.campaign &&
              this.campaign.id == creative.campaignId &&
              creative.campaignId !== null &&
              !creative.id.includes('new')
            ) {
              formData.append(
                'creatives[' + creativeIndex + '][id]',
                creative.id
              );
            }
            if (creative.url) {
              formData.append(
                'creatives[' + creativeIndex + '][url]',
                creative.url
              );
            }
            if (creative.title) {
              formData.append(
                'creatives[' + creativeIndex + '][title]',
                creative.title
              );
            }
            if (creative.description) {
              formData.append(
                'creatives[' + creativeIndex + '][description]',
                creative.description
              );
            }
            if (creative.cta) {
              formData.append(
                'creatives[' + creativeIndex + '][cta]',
                creative.cta
              );
            }
            if (creative.file) {
              formData.append(
                'creatives[' + creativeIndex + '][file]',
                creative.file
              );
            }
            if (creative.width) {
              formData.append(
                'creatives[' + creativeIndex + '][width]',
                creative.width.toString()
              );
            }
            if (creative.height) {
              formData.append(
                'creatives[' + creativeIndex + '][height]',
                creative.height.toString()
              );
            }
            if (creative.fileId) {
              formData.append(
                'creatives[' + creativeIndex + '][file_id]',
                creative.fileId.toString()
              );
            }
            if (creative.status) {
              formData.append(
                'creatives[' + creativeIndex + '][status]',
                creative.status.value
              );
            }
            if (creative?.coordinates?.length) {
              formData.append(
                'creatives[' + creativeIndex + '][coordinates]',
                JSON.stringify(creative.coordinates)
              );
            } else {
              formData.append(
                'creatives[' + creativeIndex + '][coordinates]',
                '[]'
              );
            }
            formData.append(
              'creatives[' + creativeIndex + '][position]',
              String(creativeIndex + 1)
            );
          }
        );
      } else {
        formData.append('creatives[]', '[]');
      }

      if (this.form.campaign.from_date) {
        formData.append('from_date', this.form.campaign.from_date);
      }

      if (this.form.campaign.to_date) {
        formData.append('to_date', this.form.campaign.to_date);
      }

      if (this.form.campaign.is_schedule !== null) {
        formData.append(
          'is_schedule',
          this.form.campaign.is_schedule.toString()
        );
      }

      if (this.form.campaign.schedule && this.form.campaign.schedule.length) {
        this.form.campaign.schedule.map((item: ScheduleTime, index: number) => {
          if (item.day_of_week) {
            formData.append(
              'schedule[' + index + '][day_of_week]',
              item.day_of_week
            );
          }
          if (item.times) {
            formData.append(
              'schedule[' + index + '][times]',
              JSON.stringify(item.times)
            );
          }
        });
      }

      if (
        this.form.campaign.changed_domains &&
        this.form.campaign.changed_domains.length
      ) {
        this.form.campaign.changed_domains.map(
          (item: Domains, index: number) => {
            formData.append('domains[' + index + '][domain]', item.domain);
            formData.append(
              'domains[' + index + '][status]',
              item.status?.value
            );
            if (item.coefficient) {
              formData.append(
                'domains[' + index + '][coefficient]',
                item.coefficient.toString()
              );
            }
            if (item.budget) {
              formData.append(
                'domains[' + index + '][budget]',
                item.budget.toString()
              );
            }
            if (item.clicks) {
              formData.append(
                'domains[' + index + '][clicks]',
                item.clicks.toString()
              );
            }
          }
        );
      }

      if (this.form.campaign.audiences && this.form.campaign.audiences.length) {
        this.form.campaign.audiences.map((audience) => {
          if (audience.id) {
            formData.append('audiences[]', audience.id.toString());
          }
        });
      } else {
        formData.append('audiences[]', '[]');
      }

      if (this.form.campaign.is_frequency_capping !== null) {
        formData.append(
          'is_frequency_capping',
          this.form.campaign.is_frequency_capping.toString()
        );
      }

      if (this.form.campaign.strategy_id) {
        formData.append(
          'strategy_id',
          this.form.campaign.strategy_id.toString()
        );
      }

      if (this.form.campaign.capping_type) {
        formData.append('capping_type', this.form.campaign.capping_type);
      }

      if (this.form.campaign.capping_value) {
        formData.append('capping_value', this.form.campaign.capping_value);
      }

      if (this.form.campaign.duration_type) {
        formData.append('duration_type', this.form.campaign.duration_type);
      }

      if (this.form.campaign.duration_value) {
        formData.append('duration_value', this.form.campaign.duration_value);
      }

      this.$emit('submit', formData);
    },
    changeScheduleDate(date) {
      this.form.campaign.from_date = date[0];
      this.form.campaign.to_date = date[1];
    },
    changeScheduleTime(times) {
      this.form.campaign.schedule = times;
    },
    changeFormCampaignParams(name, value) {
      this.form.campaign[name] = value;
    },
    changeFormParams(name, value) {
      this.form[name] = value;
    },
    changeFormCampaignErrors(name, value) {
      this.form.campaign.errors[name] = value;
    },
  },
  data() {
    return {
      form: {
        campaign: {
          group_id: null,
          id: null,
          name: '',
          advertiser_domain: '',
          full_name: '',
          type_traffic: typeTraffic.NATIVE,
          status: {
            label: 'Draft',
            value: 'draft',
          },
          is_unique_users: 0,
          is_use_predictor_ctr: 0,
          is_use_price_setting: 0,
          is_contextual_target: 0,
          contextual_analysis: 0,
          keywords: '',
          is_limit_budget: 0,
          is_use_target: 0,
          black_site_ids: '',
          white_site_ids: '',
          geo_type: ERegionType.INCLUDE,
          geo_values: [],
          target_type: ETargetTypes.CPM,
          impression: EImpressions.FIXED_CPM,
          max_cpc: '',
          max_cpm: '',
          increase_on: '',
          limit_type: ELimitType.SPEND,
          limit_goal: ELimitGoal.TOTAL,
          limit_budget: '',
          user_targets: [],
          is_inventory: 1,
          ssp_targets: [],
          advertising_category: [],
          languages: [],
          is_device_targets: 0,
          os: [],
          device_types: [],
          categories: [],
          errors: {},
          from_date: '',
          to_date: '',
          is_schedule: 0,
          schedule: [],
          domains: [],
          changed_domains: [],
          audiences: [],
          is_frequency_capping: 0,
          strategy_id: null,
          capping_type: ECappingType.IMPRESSIONS,
          capping_value: '',
          duration_type: EDurationType.DAY,
          duration_value: '',
        } as CampaignFormInterface,
        toggleListSites: 0,
      } as CampaignFormDataInterface,
      tabsName: {
        [ECampaignTabs.SETTINGS]: {
          name: this.$t('pages.campaignForm.tabs.options.tabName'),
          tab: ECampaignTabs.SETTINGS,
          isCheck: false,
          isValid: true,
          buttons: true,
        },
        [ECampaignTabs.TARGETS]: {
          name: this.$t('pages.campaignForm.tabs.targets.tabName'),
          tab: ECampaignTabs.TARGETS,
          isCheck: false,
          isValid: true,
          buttons: true,
        },
        [ECampaignTabs.CREATIVES]: {
          name: this.$t('pages.campaignForm.tabs.creatives.tabName'),
          tab: ECampaignTabs.CREATIVES,
          isCheck: false,
          isValid: true,
          isActivated: false,
          buttons: false,
        },
      } as ICollectionTabsData,
      activeTab: 'settings',
    };
  },
});
